var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingUpBoxMask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 700,
    viewBox: "0 0 420 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2084_1231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.018 284.046L109.915 282.192H364C364 282.192 334.226 159.294 210.243 159.294C163.036 159.294 129.25 177.132 105.492 199.198L105.287 195.607L265.061 27.9402C265.061 27.9402 168.898 -39.1268 78.1862 56.0874C63.9932 71.0297 53.2456 86.3775 45.2749 101.725C37.3042 86.3775 26.5567 71.0297 12.3637 56.0874C-78.348 -39.0689 -174.511 27.9402 -174.511 27.9402L-33.5064 175.916C-52.9961 165.839 -76.651 159.294 -105.243 159.294C-229.226 159.294 -259 282.192 -259 282.192H-9.79998L-6.76598 284.683C-43.3798 281.092 -92.8495 289.895 -137.948 343.641C-223.106 445.168 -164.226 553.935 -164.226 553.935L-19.0563 380.939L-48.3679 700H154.242L115.417 385.63L256.678 553.993C256.678 553.993 315.559 445.226 230.401 343.699C189.57 295.05 145.192 283.235 110.018 284.046Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2084_1231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 700,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingUpBoxMask);
export default __webpack_public_path__ + "static/media/setting-up-box-mask.199ea8b5d5a4bd700a06ac27acc36860.svg";
export { ForwardRef as ReactComponent };